import { Action } from '@ngrx/store';

import { FilterInterface, FilterItemInterface, SiteFilterInterface } from '../../models';

import { SiteFilterActionType } from './site-filter-action-type.enum';

export class UpdateSiteFilter implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.UpdateSiteFilter;

  constructor(public readonly payload?: SiteFilterInterface) { }
}

export class UpdateSiteFilterCompleted implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.UpdateSiteFilterCompleted;

  constructor(public readonly payload?: SiteFilterInterface) { }
}

export class UpdateSiteFilterFailed implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.UpdateSiteFilterFailed;

  constructor(public readonly payload?: string) { }
}

export class UpdateManagmentSiteFilterCategory implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.UpdateManagmentSiteFilterCategory;

  constructor(public readonly payload?: FilterInterface) { }
}

export class UpdateManagmentSiteFilterCategoryCompleted implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.UpdateManagmentSiteFilterCategoryCompleted;

  constructor(public readonly payload?: FilterInterface) { }
}

export class UpdateManagmentSiteFilterCategoryFailed implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.UpdateManagmentSiteFilterCategoryFailed;

  constructor(public readonly payload?: string) { }
}

export class UpdateManagementSiteFilterItem implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.UpdateManagementSiteFilterItem;

  constructor(public readonly payload?: { filterId: number, filterItem: FilterItemInterface }) { }
}

export class UpdateManagementSiteFilterItemCompleted implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.UpdateManagementSiteFilterItemCompleted;

  constructor(public readonly payload?: { filterId: number, filterItem: FilterItemInterface }) { }
}

export class UpdateManagementSiteFilterItemFailed implements Action {
  public readonly type: SiteFilterActionType = SiteFilterActionType.UpdateManagementSiteFilterItemFailed;

  constructor(public readonly payload?: string) { }
}
